/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import PasswordDimenticata from './pages/PasswordDimenticata';
import ReimpostaPassword from './pages/ReimpostaPassword';
import Registrazione from './pages/Registrazione';
import VerificaEmail from './pages/VerificaEmail';
import Dashboard from './pages/Dashboard';
import Interventi from './pages/Interventi';
import NuovaRichiesta from './pages/NuovaRichiesta';
import DicciLaTua from './pages/DicciLaTua';
import InterventoDetail from './pages/InterventoDetail';
import Prodotti from './pages/Prodotti';
import ProdottoDetail from './pages/ProdottoDetail';
import Inventario from './pages/Inventario';
import Notifiche from './pages/Notifiche';
import Privacy from './pages/Privacy';
import PrivacyAccount from './pages/PrivacyAccount';
import { useIdentitaApp } from './hooks/useImpostazioni';


const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30 * 1000 } },
});

// Applica nome e icona dell'installazione a titolo della scheda e favicon.
// Sta dentro il provider di react-query perche' legge le impostazioni.
function IdentitaApp() {
  useIdentitaApp('cliente', 'Area Cliente');
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <IdentitaApp />
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Fuori da ProtectedRoute: ci si arriva proprio perche' non si riesce a entrare. */}
            <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
            <Route path="/reimposta-password" element={<ReimpostaPassword />} />
            <Route path="/registrazione" element={<Registrazione />} />
            <Route path="/verifica-email" element={<VerificaEmail />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/account" element={<ProtectedRoute requiredRole="cliente"><PrivacyAccount /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requiredRole="cliente"><Dashboard /></ProtectedRoute>} />
            <Route path="/interventi" element={<ProtectedRoute requiredRole="cliente"><Interventi /></ProtectedRoute>} />
            <Route path="/interventi/:id" element={<ProtectedRoute requiredRole="cliente"><InterventoDetail /></ProtectedRoute>} />
	    <Route path="/prodotti" element={<ProtectedRoute requiredRole="cliente"><Prodotti /></ProtectedRoute>} />
            <Route path="/prodotti/:id" element={<ProtectedRoute requiredRole="cliente"><ProdottoDetail /></ProtectedRoute>} />
            <Route path="/inventario" element={<ProtectedRoute requiredRole="cliente"><Inventario /></ProtectedRoute>} />
            <Route path="/notifiche" element={<ProtectedRoute requiredRole="cliente"><Notifiche /></ProtectedRoute>} />
            <Route path="/nuovo" element={<ProtectedRoute requiredRole="cliente"><NuovaRichiesta /></ProtectedRoute>} />
            <Route path="/dicci-la-tua" element={<ProtectedRoute requiredRole="cliente"><DicciLaTua /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
